import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { Injector, LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LayoutModule } from "./layout/layout.module";
import { SharedModule } from "./shared/shared.module";
import { DesignSystemModule } from "./design-system/design-system.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule, registerLocaleData } from "@angular/common";
import { NgxPermissionsModule } from "./core/modules/permissions";
import { en_US, NZ_I18N } from "ng-zorro-antd/i18n";
import localeAR from "@angular/common/locales/ar";
import { createTranslateSharedLoader } from "./utils/createTranslateLoader";
import { LanguageInterceptor } from "./core/services/language.interceptor";
import { NgxGaugeModule } from "ngx-gauge";
import { TitlePageService } from "./core/services/titlePage.service";
import { LoaderInterceptor } from "./core/http-interceptors/loader-interceptor";

export let AppInjector: Injector;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    DesignSystemModule,
    RouterModule,
    LayoutModule,
    HttpClientModule,
    // NgxCaptureModule,
    // ColorPickerModule,
    BrowserAnimationsModule,
    NgxGaugeModule,
    NgxPermissionsModule.forRoot(),
    NgxSkeletonLoaderModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: "ar",
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateSharedLoader,
        deps: [HttpClient],
      },
      // isolate: true,
    }),
    CommonModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    TitlePageService,
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy,
    // },
    // { provide: ErrorHandler, useClass: ErrorHandlerService },
    {
      provide: NZ_I18N,
      useFactory: (localId: string) => {
        return en_US;
      },
      deps: [LOCALE_ID],
    },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    // TODO to be removed setting default language in localstorage
    if (!localStorage.getItem("locale")) {
      localStorage.setItem("locale", '"ar"');
    }
    registerLocaleData(localeAR, "ar-EG");
    AppInjector = this.injector;
  }
}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
